var ECBOT = {
  
};
ECBOT.getLoginStatus = function(callback) {
  // var url = "https://ecbothk.com/api/shop/test"
  var url = "https://ecbothk.com/login"
  var next = "https://ecbothk.com/api/shop/test"
  var loginWindow = window.open(url+'?next=' + encodeURIComponent(next),'_blank','height=600,width=900,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no');
    var timer = setInterval(function() {
      if(loginWindow.closed) {
          clearInterval(timer);
          const buttonECBOT = document.getElementsByClassName('sso-login-ecbot')[0];
          buttonECBOT.disabled = false;
          buttonECBOT.title = "";
          showError("Action canceled")
          console.log('窗口已关闭');
      }
  }, 500);
    window.addEventListener("message", function(event) {
        console.log(12312313, event.data, event.origin)
        // 确保消息来自期望的源
        if (event.origin !== "https://ecbothk.com")
            return;
        const buttonECBOT = document.getElementsByClassName('sso-login-ecbot')[0];
          buttonECBOT.disabled = false;
          buttonECBOT.title = "";
        // 解析消息数据
        var data = JSON.parse(event.data);
      console.log(data)
        // 检查 action
        if (data.action === "postLogin") {
           // 拿到登录信息
          var loginResult = event.data; 
          callback({
            "data": event.data,
            "status": "connected"});
          
        }
        else if (data.action === "canceled") {
        showError("Action canceled")
      }
       else{
            showError("invalid message")
        }
    }, false);
};


function testAPI(data) {
  console.log('Welcome! Fetching your information1.... ');
  var data = JSON.parse(data)
  var url = 'https://shop.ecbothk.com/account/login';
  var formData = new FormData();

  formData.append('customer[email]', data.user.email);
  formData.append('customer[password]', data.user.password);
  formData.append('form_type', 'customer_login');
  // 解析当前的 URL
  var currentUrl = new URL(window.location.href);

  // 获取 checkout_url 参数的值
  var checkoutUrl = currentUrl.searchParams.get('checkout_url');

  // 如果 checkout_url 存在，则设置 return_to 为 checkout_url
  if (checkoutUrl) {
    formData.append('return_to', checkoutUrl);
  }
  const ssoLoginSection = document.getElementsByClassName("sso-login-section")[0]
  const pMessage = document.getElementsByClassName("processing message")[0]
  ssoLoginSection.style.display = 'none';
  pMessage.style.display = 'block';
  fetch(url, {
    method: 'POST',
    body: formData,
    redirect: 'follow',  // 重定向的处理方式
  })
  .then(response => {
    console.log("=======", response.redirected, response.url)
    if (response.redirected) {
      window.location.href = response.url;  // 如果发生了重定向，从这里获取到新的URL
      console.log('Welcome! Fetching your information2.... ');
      // 在这里发送webhook
        // const webhookData = {"data":data.user.email};  

        // fetch('https://ecbothk.com/api/webhooks/loginCallback', {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         // 'X-HMAC-SHA256': hmac.toString()  // 将 HMAC 添加到请求头中
        //     },
        //     body: JSON.stringify(webhookData)
        // })
        // .then(response => console.log(response))
        // .catch(error => console.error('Error:', error));
    }
    return response.text();
  })
  .then(result => console.log(result))
  .catch(error => console.log('error', error));
}


function checkECBotLoginState() {
  ECBOT.getLoginStatus(function(response) {
   if (response.status === 'connected') {
      testAPI(response.data);
      // statusChangeECBotCallback(response);
    } else {
      console.log("not ok")
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  
  console.log("welcome to ecbothk")
  const buttonECBOT = document.getElementsByClassName('sso-login-ecbot')[0];
  buttonECBOT.addEventListener('click', () => {
    // 禁用按钮并添加提示信息
    buttonECBOT.disabled = true;
    buttonECBOT.title = "loading，please waiting...";
    checkECBotLoginState();
  });
});
function showError(errorText) {
// 获取错误消息元素
  var errorMessageElement = document.getElementById('error-message');
  var errorsContainer = document.getElementById('error-text');

  // 创建一个错误信息的列表
  var ul = document.createElement('ul');

  // 创建一个错误信息
  var li = document.createElement('li');
  li.textContent = errorText

  // 将错误信息添加到列表中
  ul.appendChild(li);

  // 清空错误消息元素
  while (errorsContainer.firstChild) {
      errorsContainer.removeChild(errorsContainer.firstChild);
  }

  // 将错误信息的列表添加到错误消息元素
  errorsContainer.appendChild(ul);

  // 显示错误消息元素
  errorMessageElement.style.display = 'block';
}